import { render, staticRenderFns } from "./DettaglioConvenzione.vue?vue&type=template&id=abefc624&"
import script from "./DettaglioConvenzione.vue?vue&type=script&lang=js&"
export * from "./DettaglioConvenzione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports